module.exports = __webpack_public_path__ + "img/IMG_1888.f7961186.jpg";